// The value read from the customer's photo, with the photo it came from
// (2026-10-19; photoLabel.js). An eBay photo is shown from its own URL, as the
// messages pane already shows it; an email attachment through the same
// authenticated download the attachment links use.
import { useEffect, useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { fetchAttachmentObjectUrl } from './api.js'
import { photoLabelText, photoLabelImage } from './photoLabel.js'

export function PhotoLabelLine({ read, conversationId, messages }) {
  const text = photoLabelText(read)
  const image = photoLabelImage(read, messages)
  const [src, setSrc] = useState(image?.kind === 'ebay' ? image.url : null)
  const attachmentId = image?.kind === 'attachment' ? image.attachmentId : null
  const ebayUrl = image?.kind === 'ebay' ? image.url : null
  useEffect(() => {
    if (ebayUrl) { setSrc(ebayUrl); return undefined }
    if (!attachmentId || !conversationId) { setSrc(null); return undefined }
    let cancelled = false
    let objectUrl = null
    fetchAttachmentObjectUrl(conversationId, attachmentId)
      .then((u) => { objectUrl = u; if (!cancelled) setSrc(u) })
      .catch(() => { if (!cancelled) setSrc(null) })
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl) }
  }, [conversationId, attachmentId, ebayUrl])
  if (!text) return null
  return (
    <Stack direction="row" spacing={1} alignItems="center" data-testid="photo-label-line" sx={{ mt: 1, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
      {src && (
        <Box component="img" src={src} alt="customer photo" data-testid="photo-label-thumbnail"
          sx={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 0.5, border: 1, borderColor: 'divider', flexShrink: 0 }} />
      )}
      <Typography fontSize="0.85rem" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>{text}</Typography>
    </Stack>
  )
}
